import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { joinWorkspaceViaLink } from '../../actions';

const JoinWorkspace = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const isAuthenticated = !!localStorage.getItem('token');

  const [status, setStatus] = useState('idle'); // idle | joining | error
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    if (!isAuthenticated) {
      localStorage.setItem('pendingInviteToken', token);
      navigate('/signin', { replace: true });
      return;
    }

    setStatus('joining');
    dispatch(joinWorkspaceViaLink(token, (err, data) => {
      if (err) {
        setStatus('error');
        setErrorMessage(err);
        return;
      }

      const workspaceId = data?.workspaceId;
      if (workspaceId) {
        localStorage.setItem('workspaceId', workspaceId);
        sessionStorage.setItem('workspaceId', workspaceId);
      }
      navigate('/select-workspace', { replace: true, state: { joinedWorkspaceName: data?.workspaceName } });
    }));
  }, [token]);

  if (status === 'error') {
    return (
      <div className="flex flex-col items-center justify-center h-screen gap-4">
        <img src="/images/icons/logo.svg" height={34} alt="logo" />
        <p className="text-red-500 font-medium">{errorMessage}</p>
        <button
          onClick={() => navigate('/')}
          className="text-sm text-blue-500 hover:underline"
        >
          Go to your workspace
        </button>
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center justify-center h-screen gap-3">
      <img src="/images/icons/logo.svg" height={34} alt="logo" />
      <p className="text-sm text-gray-500">Joining workspace...</p>
    </div>
  );
};

export default JoinWorkspace;
